module.exports = __webpack_public_path__ + "static/img/mb-04.75eab93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/mb-04.jpg
// module id = uYKp
// module chunks = 1